/* eslint-disable import/prefer-default-export */
import {Types} from '../../request';
import ApiTag from '../apiTags';

// Body
// {"loginId":7220822022,
//  "custId":40769476309,
//  "resCountryId":77
// }

// Output Description:
// {"customerid":40769476309,"country":77,"status":"success","findForward":"success"}

export const logout = (loginId, custId, resCountryId, emailId) => {
  // let loginId = (resCountryId === "77" || resCountryId === 77) ? login_id : 7220822022;

// console.log("loginId",loginId);

  return {
    url: '/signup/logoutApplication',
    payload: {loginId, custId, resCountryId, emailId},
    type: Types.POST,
    tag: ApiTag.LOGOUT,
    headers: {}
  };
};
